import type { DoctorReview } from '@models/consultant';

export type DoctorClinicPayloadModel = {
  doctorId: string;
  pageNumber?: number;
  pageSize?: number;
};

export type DoctorClinicItemModel = {
  id: number;
  doctorId: number;
  title: string;
  cityId: number;
  areaId: number | null;
  isActive: boolean;
  clinicType: number;
  latitude: number;
  longitude: number;
  clinicAddress: string;
  primaryNumber: string;
  secondaryNumber: string | null;
  description: string | null;
};

export type DoctorClinicResponseModel = {
  data: DoctorClinicItemModel[];
};

export type CalendarPayloadModel = {
  doctorId: string;
  clinicId: number;
};
export type CalendarItemModel = {
  calendarId: number;
  date: number;
  capacity: number;
  calendarDate: string;
  isActive: boolean;
};

export type CalendarResponseModel = {
  data: CalendarItemModel[];
};

export type CalendarAvailableTimeSlotsPayloadModel = {
  doctorId: string;
  clinicId: number;
  date: number;
};

export type CalendarAvailableTimeSlotsItemModel = {
  date: string;
  isActive: true;
  timeSlot: string;
};

export type CalendarAvailableTimeSlotsResponseModel = {
  data: CalendarAvailableTimeSlotsItemModel[];
};

export type InPersonBookingCitiesPayloadModel = {
  latestSpecialityId?: string | number;
};

export type InPersonBookingCitiesResponseModel = {
  data: {
    doctorCount: number;
    id: number;
    name: string;
  }[];
};

export enum ActiveTabEnum {
  'MORNING' = 0,
  'NOON' = 1,
  'NIGHT' = 2,
}

export type TabLabel = {
  id: ActiveTabEnum;
  label: string;
};

export type InPersonBookingReservePayloadModel = {
  clinicId: number;
  doctorId: number;
  calendarId: number;
  firstName: null;
  lastName: null;
  phoneNumber: null;
  nationalCode: null;
  date: string;
  timeSlot: string;
};

export type GetInPersonBookingPayloadModel = {
  clinicId: number;
  doctorId: number;
  calendarId: number;
  timeSlot: string;
};

export type GetInPersonBookingResponseModel = {
  data: {
    calendarId: number;
    clinicId: number;
    code: string;
    date: string;
    doctorId: number;
    duration: number;
    firstName: string | null;
    lastName: string | null;
    nationalCode: string | null;
    phoneNumber: string | null;
    recId: number;
    status: number;
    timeSlot: string;
  };
};

export type InPersonBookingUpdatePayloadModel = {
  recId: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  nationalCode: string;
  isForAnotherPerson: boolean;
};

export interface InPersonBookingHistory {
  id?: number;
  recId: number;
  doctorId: number;
  date: string;
  timeSlot: string;
  status: InPersonBookingStatus;
  doctorFullName?: string;
  doctorSpecialty?: string;
  hasReview: boolean;
  doctorReview?: DoctorReview | null;
  doctorReviews?: DoctorReview[] | null;
}

export enum InPersonBookingStatus {
  Draft = 0,
  Confirmed = 1,
  Rejected = 2,
  Finished = 3,
}

export type GetInPersonBookingHistoryParams = {
  status?: number[];
  pageNumber?: number;
  pageSize?: number;
};

export type InPersonBookingHistoryPageData = {
  pageNumber: number;
  pageSize: number;
  queryResult: InPersonBookingHistory[];
  totalCount: number;
};

export type InPersonBookingHistoryResponse = {
  isSuccess: boolean;
  message: string;
  resultCode: string;
  errors: string | null;
  data: InPersonBookingHistoryPageData;
};

export type PaginatedInPersonBookingHistoryResponse = {
  pageParams: number[];
  pages: InPersonBookingHistoryResponse[];
};

export type InPersonBookingDoctorDetails = {
  recId: number;
  fullName?: string;
  imageUrl?: string;
  specialty?: string;
};

export interface InPersonBookingHistoryDetail {
  recId: number;
  clinicId?: number;
  doctorId: number;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  date?: string;
  timeSlot?: string;
  status?: InPersonBookingStatus;
  code?: string;
  referralReason?: string | null;
  clinicAddress?: string | null;
  primaryNumber?: string | null;
  secondaryNumber?: string | null;
  hasReview: boolean;
  doctorReview?: DoctorReview | null;
  doctorReviews?: DoctorReview[] | null;
  trackingCode?: string;
  createDateTime?: string;
  clinicPhoneNumber?: string;
  id?: number;
  latitude?: number;
  longitude?: number;
}

export type InPersonBookingHistoryDetailResponse = {
  isSuccess: boolean;
  message: string;
  resultCode: string;
  errors: string | null;
  data: InPersonBookingHistoryDetail;
};

export type DoctorReviewSource = {
  doctorReview?: DoctorReview | null;
  doctorReviews?: DoctorReview[] | null;
  reviews?: DoctorReview[] | null;
};
